// @ts-nocheck
import * as React from 'react';
// SourceBadge — colored uppercase source label.

export default function SourceBadge({ source }) {
  const colors = {
    Website: "#1769ff",
    Referral: "#16a34a",
    "Walk-in": "#b45309",
    Instagram: "#db2777",
    "Google Ads": "#0891b2",
    "Open House": "#7c3aed",
    WhatsApp: "#15803d",
  };
  const c = colors[source] || "#525252";
  return (
    <span
      style={{
        fontSize: 10,
        fontWeight: 700,
        color: c,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
      }}
    >
      {source}
    </span>
  );
}
